import About from "./Components/About";
import Home from "./Components/Home";
import Navbar from "./Components/Navbar";
// import Sociallinks from "./Components/Sociallinks";

import Portfolio from "./Components/Portfolio";
import Experience from "./Components/Experience";
import Contact from "./Components/Contact";

function App() {
  return (


    <>
     
     <Navbar/>
     {/* <Sociallinks /> */}
     <Home />
     <About />
     <Portfolio />
     <Experience />
     <Contact />



    </>
     );
}

export default App;
